module.exports = __webpack_public_path__ + "img/2exp.5ffd407c.jpg";